<template>
  <b-modal
    :active="isModalActive"
    :canCancel="['escape', 'outside']"
    v-on="$listeners"
    has-modal-card
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <span>カテゴリ絞り込み</span>
        <a
          class="c-modalClose"
          href="javascript:;"
          @click="close"
        >
          <coconala-icon
            name="cross"
            size="12px"
          />
        </a>
      </header>
      <div class="modal-card-body -top">
        <div class="c-modalForm">
          <p>カテゴリ選択</p>
          <div class="c-modalForm_selectBox">
            <c-select
              size="is-medium"
              placeholder="カテゴリを選択してください"
              @change.native="setCategories()"
              v-model="parentMasterCategoryId"
            >
              <option value="">すべて</option>
              <option
                v-for="(category, index) in filteredCategories"
                :value="category.id"
                :key="index"
              >{{ category.name }}</option>
            </c-select>
          </div>
          <p>カテゴリを絞り込む</p>
        </div>
      </div>
      <div
        class="modal-card-body -scrollable"
        ref="body"
      >
        <div
          class="c-modalForm"
          v-if="parentMasterCategoryId"
        >
          <ul class="c-modalForm_checkList">
            <li
              class="c-modalForm_checkGroup -all"
              :value="parentMasterCategoryId"
            >
              <c-radio
                v-model="selectedMasterCategoryId"
                size="is-small"
                id="'category-all'"
                :native-value="parentMasterCategoryId"
              >
                <span>すべて</span>
              </c-radio>
            </li>
            <li
              class="c-modalForm_checkGroup -sub"
              v-for="subCategory in subMasterCategories"
              :key="subCategory.id"
            >
              <span class="c-modalForm_checkGroupItem">
                <c-radio
                  v-model="selectedMasterCategoryId"
                  size="is-small"
                  :id="'category-' + subCategory.id"
                  :native-value="subCategory.id"
                >
                  <span>{{ subCategory.name }}</span>
                </c-radio>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-card-body -bottom">
        <div class="c-modalForm"></div>
      </div>
      <footer class="modal-card-foot">
        <c-button
          @click="close"
          :size="isSP ? '' : 'medium'"
        >閉じる</c-button>
        <c-button
          @click="search"
          :size="isSP ? '' : 'medium'"
          color="primary"
        >絞り込む</c-button>
      </footer>
    </div>
  </b-modal>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

// modules
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
  name: 'SearchCategoryModal',
  props: {
    isModalActive: {
      type: Boolean,
      default: false
    },
    modalCategory: {
      type: Object,
      default: () => {}
    },
    conditionsCategories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedMasterCategoryId: null,
      selectedMasterCategory: {},
      parentMasterCategoryId: null,
      subMasterCategories: []
    }
  },
  watch: {
    selectedMasterCategoryId: {
      handler(v) {
        if (!v) {
          this.selectedMasterCategory = {
            id: null,
            name: ''
          }
        } else if (v === this.parentMasterCategoryId) {
          this.selectedMasterCategory = this.masterCategories.find(
            masterCategory => masterCategory.id === v
          )
        } else {
          this.selectedMasterCategory = this.subMasterCategories.find(c => c.id === v)
        }
      }
    },
    isModalActive(v) {
      if (v) {
        this.selectedMasterCategoryId = this.modalCategory.id
        this.parentMasterCategoryId = this.modalCategory.parentCategoryId
        if (this.modalCategory.parentCategoryId) {
          this.subMasterCategories = this.masterCategories.find(
            masterCategory => masterCategory.id === this.modalCategory.parentCategoryId
          )?.subCategories
          if (this.isBusinessCategory) {
            this.subMasterCategories = this.subMasterCategories.filter(
              subMasterCategory => subMasterCategory.businessFlag
            )
          }
        }
        this.$nextTick(() => {
          disableBodyScroll(this.$refs.body)
        })
      } else {
        enableBodyScroll(this.$refs.body)
      }
    }
  },
  computed: {
    ...mapState('master', ['masterCategories']),
    ...mapState('auth/user', ['isBusiness']),
    ...mapGetters('master', ['businessMasterCategories']),
    isSP() {
      return ['sp'].includes(this.$store.state.ui.viewport.device)
    },
    isBusinessCategory() {
      return !!this.$route.query.is_business || this.isBusiness
    },
    filteredCategories() {
      return this.isBusinessCategory ? this.businessMasterCategories : this.masterCategories
    }
  },
  methods: {
    close() {
      this.selectedMasterCategoryId = Number(this.modalCategory.id)
      this.selectedMasterCategory = this.modalCategory
      this.$emit('close')
    },
    search() {
      this.$emit('change', {
        selectedCategory: this.selectedMasterCategory,
        parentCategoryId: this.parentMasterCategoryId
      })
      this.$emit('close')
    },
    setCategories() {
      this.subMasterCategories = []
      if (this.parentMasterCategoryId) {
        this.selectedMasterCategoryId = this.parentMasterCategoryId
        this.subMasterCategories = this.masterCategories.find(
          masterCategory => masterCategory.id === this.parentMasterCategoryId
        ).subCategories
        if (this.isBusinessCategory) {
          this.subMasterCategories = this.subMasterCategories.filter(sc => sc.businessFlag)
        }
      } else {
        this.selectedMasterCategoryId = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-card {
  z-index: z(modal, wrapper);
  border-radius: 5px;
  background-color: $color-white;

  &-head {
    justify-content: center;
    padding: 8px 16px;
    background-color: $color-white;
    font-weight: bold;
    font-size: 16px;

    .c-modalClose {
      position: absolute;
      right: 12px;
      color: $color-gray-700;
    }
  }

  &-body {
    overflow: visible;
    background-color: $color-gray-50;

    &.-top {
      margin: 16px 16px 0;
      padding: 12px 16px 0;
      border-bottom: 1px solid $color-gray-200;
      border-radius: 5px 5px 0 0;

      p {
        margin-bottom: 4px;
        color: $color-gray-600;
        font-weight: bold;
        font-size: 12px;
      }
    }

    &.-scrollable {
      overflow: auto;
      margin: 0 16px;
      padding: 8px 16px;
      height: calc(100vh - 400px);
    }

    &.-bottom {
      margin: 0 16px;
      padding: 0 0 5px;
      border-radius: 0 0 5px 5px;
    }
  }

  &-foot {
    display: flex;
    justify-content: center;
    padding: 16px;
    border: 0;
    background-color: $color-white;

    .button {
      display: block;
      width: 50%;
    }
  }
}

.c-modalForm {
  &_selectBox {
    margin-bottom: 12px;

    /deep/ select {
      max-width: 100%;
      width: 250px;
    }
  }

  &_checkAll {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid $color-gray-200;
    font-weight: bold;
  }

  &_checkGroup {
    &.-all {
      border-bottom: 1px solid $color-gray-200;
      padding-bottom: 8px;
      margin-bottom: 8px;
    }

    &.-sub {
      padding: 4px 0 4px 20px;
    }
  }

  &_checkGroupItem {
    margin-right: 8px;
  }

  &_checkGroupItemCount {
    color: $color-gray-600;
    font-weight: normal;
  }

  .b-radio {
    white-space: nowrap;

    &.radio {
      & + .radio {
        margin-left: 0;
      }
    }
  }
}

@media (max-width: breakpoint(Requests, S)) {
  .modal-card {
    top: -20px;
  }

  .c-modalForm {
    &_checkGroupItem {
      display: block;
    }
  }
}
</style>
